import { CloseCircleOutlined } from '@ant-design/icons'
import { useChangeSelfPassword } from '@services/user'
import { createFormItemLayout, rules } from '@shared/innmaxLib/utils/form'
import { Modal } from '@shared/innmaxUI'
import { Button, Input } from '@shared/innmaxUI/Form'
import { Form, ModalProps } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'
import usePasswordValidation from 'src/hooks/usePasswordValidation'
import { FormItem } from '../Form'

interface IChangePasswordModalProps extends ModalProps {
  title?: string
  description?: string
}

const formItemLayout = createFormItemLayout(4, 20)

const ChangePasswordModal = React.memo<IChangePasswordModalProps>(props => {
  const [form] = Form.useForm()

  const { t } = useTranslation()

  const { onOk, title, onCancel, description, ...others } = props

  const [isChangeMineMutate, changeMineMutate] = useChangeSelfPassword()

  const { compareToFirstPassword, validateToNextPassword } =
    usePasswordValidation({
      firstFieldName: 'newPassword',
      secondFieldName: 'newPasswordConfirm',
    })

  return (
    <Modal
      {...others}
      footer={
        <div className="text-right">
          <Button
            style={{ minWidth: 80 }}
            type="primary"
            loading={isChangeMineMutate}
            onClick={() => form.submit()}>
            確認
          </Button>
        </div>
      }
      width="60%"
      maskClosable={false}
      style={{ maxWidth: '1000px' }}
      closeIcon={
        <CloseCircleOutlined
          onClick={e => {
            onCancel && onCancel(e)
          }}
          style={{ fontSize: '22px', color: '#fff' }}
        />
      }
      title={title}>
      <Form
        form={form}
        onFinish={async values => {
          changeMineMutate(values, {
            onSuccess: onOk,
          })
        }}
        colon={false}
        labelAlign="left">
        <FormItem noStyle>
          <p>{description}</p>
        </FormItem>
        <FormItem
          {...formItemLayout}
          colon={false}
          name="password"
          rules={[rules.required]}
          label={'原密碼'}>
          <Input
            type="password"
            placeholder={'請輸入原密碼'}
            className="w-320"
          />
        </FormItem>
        <FormItem
          {...formItemLayout}
          colon={false}
          name="newPassword"
          rules={[rules.password, validateToNextPassword]}
          label={t('user:new password')}>
          <Input
            type="password"
            placeholder={t('user:input password')}
            className="w-320"
          />
        </FormItem>
        <FormItem
          {...formItemLayout}
          colon={false}
          label={t('user:re-type')}
          name="newPasswordConfirm"
          rules={[rules.password, compareToFirstPassword]}>
          <Input
            type="password"
            placeholder={t('user:input password again')}
            className="w-320"
          />
        </FormItem>
      </Form>
    </Modal>
  )
})

export default ChangePasswordModal
